module.exports = __webpack_public_path__ + "static/media/pinturas-ico.118e2f66.svg";